import React, { useState } from "react";
import TeamModal from "./teamModal";

const images = [
    { src: "/images/2025.png", title: "The Team" },
    { src: "/images/car.png", title: "The Car" },
    { src: "/images/christmasDinner.jpg", title: "Team Moments" },
    { src: "/images/back.png", title: "Behind the Scenes" },
    { src: "/images/card.jpg", title: "Design Work" },
    { src: "/images/team.png", title: "Full Team" },
];

const TheTeamMobile: React.FC = () => {
    const [isTeamOpen, setIsTeamOpen] = useState(false);

    return (
        <section className="w-full bg-gradient-to-b from-[#0e0e0e] to-[#201647] py-16 text-white">

            {/* Title */}
            <h2 className="text-3xl font-light mb-4 text-center px-5">
                The Team
            </h2>

            <hr className="mx-8 pb-8"/>


            {/* Horizontal Scroll */}
            <div className="overflow-x-auto no-scrollbar">
                <div className="flex gap-4 px-5 snap-x snap-mandatory">

                    {images.map((item, index) => (
                        <div
                            key={index}
                            className="min-w-[80%] snap-center relative"
                        >
                            <img
                                src={item.src}
                                className="w-full h-[300px] object-cover rounded-2xl"
                            />

                            {/* Overlay */}
                            <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black/70 to-transparent rounded-b-2xl">
                                <h3 className="text-lg font-semibold">
                                    {item.title}
                                </h3>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            {/* CTA */}
            <div className="mt-10 flex justify-center">
                <button
                    onClick={() => setIsTeamOpen(true)}
                    className="px-6 py-3 border border-white/30 rounded-xl text-sm uppercase tracking-widest hover:bg-white hover:text-black transition"
                >
                    See The Team
                </button>
            </div>

            <TeamModal
                isOpen={isTeamOpen}
                onClose={() => setIsTeamOpen(false)}
            />
        </section>
    );
};

export default TheTeamMobile;